import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, MagiisAccessCarrierProfileDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";


export class GetAllMagiisAccessCarrierProfile extends IRequestCommand<
  IGetAllMagiisAccessCarrierProfileResponse,
  ErrorDetails,
  IGetAllMagiisAccessCarrierProfileParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override setParameters(parameters: IGetAllMagiisAccessCarrierProfileParameters) {
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`carrierprofiles`);
    this.urlSections.push(String(parameters.carrierAccountId));
    this.paramsSections.push(`status=${parameters.status}`)
    this.composeUrl();
  }
}

export interface IGetAllMagiisAccessCarrierProfileParameters extends ICommandParameters{
  carrierAccountId: number;
  status: number;
}

export type IGetAllMagiisAccessCarrierProfileResponse = MagiisAccessCarrierProfileDTO[];
